
import { Component, Vue } from "vue-property-decorator";
import { AppLauncher } from "@capacitor/app-launcher";
import Screen from "@/app/modules/_global/classes/Screen";

@Component
export default class HomePage extends Vue {
  boundedContentHeight = 0;

  get appData() {
    return this.$store.getters["app/data"];
  }

  get whiteboardMenuItem() {
    return this.appData.nav_menu_items.find(_ => _.route == "posts");
  }

  beforeDestroy() {
    this.scrollTop();
  }

  created() {
    this.$nextTick(() => {
      const screen = new Screen();
      this.boundedContentHeight = screen.getBoundedContentHeight();
    });
  }

  async openUrl(url: string) {
    await AppLauncher.openUrl({ url });
  }

  scrollTop() {
    const card = document.getElementById("card");
    if (card) card.scrollIntoView({ behavior: "smooth" });
  }
}
